(function(module) {
    'use strict';

    function LoginConfig($stateProvider, $translatePartialLoaderProvider) {

        // Route
        $stateProvider
            .state('login', {
                url: '/login?redirect=:redirectUrl',
                data: {
                    pageTitle: 'LOGIN.PAGE_TITLE',
                },
                views: {
                    'main@': {
                        templateUrl: '/js/components/layouts/content-only.html',
                        controller: 'MainController as $ctrl',
                    },
                    'content@login': {
                        templateUrl: '/js/authentication/login/login.html',
                        controller: 'LoginCtrl as $ctrl',
                    },
                },
                params: {
                    redirectUrl: {
                        value: null,
                        squash: false,
                    },
                    redirect: {
                        value: null,
                        squash: false,
                    },
                },
                bodyClass: 'page--login',
            });

        // Translations
        $translatePartialLoaderProvider.addPart('/js/authentication/login');

    }

    function LoginCtrl(LoopBackAuth, User, Store, $state, $stateParams, $location, $window) {
        this.$onInit = () => {
            if (User.isAuthenticated()) {
                Store.setCurrentSubAccountId(null);

                LoopBackAuth.clearUser();
                LoopBackAuth.clearStorage();
            }
        };

        this.login = () => {
            User
                .login({
                    email: this.user.email.toLowerCase(),
                    password: this.user.password,
                })
                .$promise
                .then((res) => {
                    if (!res.accountId) {
                        $state.go('register-account');
                    } else if (!_.get(res, 'user.emailVerified')) {
                        $state.go('verify-email');
                    } else if ($stateParams.redirect) {
                        $state.go($stateParams.redirect);
                    } else if ($stateParams.redirectUrl) {
                        $window.location.href = $stateParams.redirectUrl;
                    } else {

                        if(res.user.permissions.main === true || res.user.isAccountAdmin === true) {
                            Store.setCurrentSubAccountId(null);
                        } else {
                            let foundSubAccount;
                            const subAccountIds = Object.keys(res.user.permissions);
                            subAccountIds.forEach( (subAccountId) => {
                                if(subAccountId === 'main') return;

                                if(!foundSubAccount && res.user.permissions[subAccountId] === true) {
                                    foundSubAccount = true;
                                    Store.setCurrentSubAccountId(subAccountId);
                                }
                            });
                        }

                        $state.go('root.home');
                    }
                })
                .catch((res) => {
                    this.api = {};
                    const code = _.get(res, 'data.error.code', null);
                    switch (code) {
                        case 'LOGIN_FAILED':
                            this.api.loginFailed = true;
                            break;
                        case 'LOGIN_FAILED_EMAIL_NOT_VERIFIED':
                            this.api.emailNotVerified = true;
                            break;
                        default:
                            this.api.error = true;
                    }
                });
        };

    }

    module
        .config(LoginConfig)
        .controller('LoginCtrl', LoginCtrl);

})(angular.module('rocket.components'));
